import useClientQuery from './useClientQuery';

export type { ClientQueryCacheKey, ClientQueryOptions } from './useClientQuery';

export default useClientQuery;
